import React from 'react';
import IconSvg, { IconSvgProps } from './IconSvg';

const CheckCircle = (props: IconSvgProps) => (
  <IconSvg {...props}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z" />
  </IconSvg>
);

export default CheckCircle;
